import { useMutation } from '@tanstack/react-query';

import accountClient, { ILocationFormInputs } from '@clients/accountsClient';
import notifyAPIError from '@utils/notifyAPIError';

const { addNewLocation } = accountClient();

const useAddNewlocation = (
    accountId: number,
    onSuccess?: () => void,
    onError?: () => void,
) => {
    const { data, error, isError, isLoading, isSuccess, mutate } = useMutation(
        ['useAddNewLocation'],
        (dataToSubmit: ILocationFormInputs) =>
            addNewLocation({
                accountId,
                dataToSubmit,
            }),
        {
            onSuccess: onSuccess,
            onError: (error) => {
                notifyAPIError(error);
                onError();
            },
        },
    );

    return { data, error, isError, isLoading, isSuccess, mutate };
};

export default useAddNewlocation;
